/*
 * @Author: ai.Zhiming
 * @Date: 2019-6-27
 * @LastEditTime: 2021-12-10 14:53:47
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\left\customLeft\customLeft.js
 * @Description: 常用订阅左侧导航
 */
angular.module('customLeftModule', [])
    . directive('customLeft', ['$state', '$timeout', function($state, $timeout) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                customList: '='
            },
            templateUrl: './editingCenter/iWo/left/customLeft/customLeft_tpl.html',
            link(scope, $element, $attrs) {
                initStatus();

                /**
             * [autoLocation description] 自动定位
             * @return {[type]} [description]
             */
                function autoLocation() {
                    let timer = $timeout(() => {
                        let routerArray = $state.current.name.split('.');
                        if (routerArray.length < 4 || routerArray[3] !== 'custom') {
                            $element.find('li a')[0].click();
                        } else {
                            scope.status.selectedNode = $state.params.customid;
                        }
                    });
                    scope.$on('$destroy', () => {
                        $timeout.cancel(timer);
                    });
                }

                /**
                 * [selectLeve3 description] 选中三级节点
                 * @param  {[type]} item [description] 节点名称
                 * @return {[type]}      [description]
                 */
                scope.selectLeve3 = function(item) {
                    var router = item.CUSTOM === '邮件稿' ? 'front.editctr.iWo.emaildraft' : item.ISUGC == '1' ? 'front.editctr.iWo.customforugc' : 'front.editctr.iWo.custom';
                    scope.status.selectedNode = item.CUSTOMID;
                    $state.go(router, {
                        'customid': item.CUSTOMID,
                        'customtype': item.CUSTOMTYPE,
                        'mycustomid': item.MYCUSTOMID,
                        'isugc': item.ISUGC
                    }, {
                        reload: router
                    });
                };

                /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
                function initStatus() {
                    scope.status = {};
                    autoLocation();
                }
            }
        };
    }]);
